import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { dec, eur } from "@/components/excelVoce/format";
import { DETR_LABEL } from "./labels";

const Linea = ({ label, v, testid, cls = "" }) => (
  <div className={`flex justify-between gap-4 text-sm py-1 ${cls}`} data-testid={testid}><span>{label}</span><span className="font-mono">{v}</span></div>
);

export const SalDetrazioni = ({ x, act }) => (
  <div className="rounded-md border p-4 max-w-xl ml-auto w-full" data-testid="sal-totali">
    <Linea label="Importo lordo precedente" v={eur(x.lordo_precedente)} testid="tot-lordo-precedente" />
    <Linea label="Importo lordo del periodo" v={eur(x.lordo_periodo)} testid="tot-lordo-periodo" cls="font-semibold" />
    <Linea label="Importo lordo cumulato" v={eur(x.lordo_cumulato)} testid="tot-lordo-cumulato" />
    <div className="border-t my-2" />
    {x.detrazioni.map((d) => (
      <div key={d.id} className="flex justify-between gap-2 text-sm py-1" data-testid={`detr-${d.tipo}`}>
        <span>− {DETR_LABEL[d.tipo]}{d.percentuale && d.tipo !== "RITENUTA_INFORTUNI" ? ` ${dec(d.percentuale, 0, 2)}%` : ""}
          {!d.calcolato && <span className="text-[11px] text-slate-500"> · {d.motivo} ({d.autore})</span>}
          {d.tipo === "RECUPERO_ANTICIPAZIONE" && d.calcolato === false && act.recuperoAuto && <button type="button" className="ml-2 text-[11px] text-sky-700 underline" onClick={act.recuperoAuto} data-testid="detr-recupero-auto">ripristina calcolo</button>}
        </span>
        <span className="font-mono flex items-center gap-1">{eur(d.importo)}
          {d.tipo === "ALTRA" && act.eliminaDetr && <Button size="sm" variant="ghost" className="h-6 px-1" onClick={() => act.eliminaDetr(d)} data-testid={`detr-elimina-${d.id}`}><Trash2 className="h-3 w-3" /></Button>}
        </span>
      </div>))}
    {!x.detrazioni.length && <p className="text-xs text-slate-500">Nessuna detrazione prevista dal contratto.</p>}
    {Number(x.anticipazione) > 0 && <p className="text-[11px] text-slate-500 mt-1" data-testid="tot-anticipazione-residua">Anticipazione residua prima di questo SAL: {eur(x.anticipazione_residua)} su {eur(x.anticipazione)}</p>}
    <div className="flex flex-wrap gap-2 mt-2">
      {act.recupero && Number(x.anticipazione) > 0 && <Button size="sm" variant="outline" onClick={act.recupero} data-testid="detr-recupero-manuale">Rettifica recupero</Button>}
      {act.altra && x.altre_detrazioni && <Button size="sm" variant="outline" onClick={act.altra} data-testid="detr-aggiungi">Altra detrazione</Button>}
    </div>
    <div className="border-t my-2" />
    <Linea label="NETTO DEL PERIODO" v={eur(x.netto)} testid="tot-netto" cls="font-bold" />
    {x.importo_liquidato !== null && <Linea label={`Liquidato il ${x.data_liquidazione}`} v={eur(x.importo_liquidato)} testid="tot-liquidato" />}
    {x.importo_liquidato !== null && <Linea label="Pagato" v={eur(x.pagato)} testid="tot-pagato" cls="text-emerald-700" />}
  </div>
);
